var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"section-space"}),_c('headers-section'),_c('features-section'),_c('blog-section'),_c('teams-section'),_c('projects-section'),_c('pricing-section'),_c('testimonial-section'),_c('contact-section')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }